export const storageLocal = {
  get: elements => {
    return Promise.resolve().then(() => {
      let data = []
      let item = null
      elements.forEach(element => {
        item = localStorage.getItem(element)
        if (!data || data === undefined) {
          item = null
        }
        data.push(item)
      })
      return data
    })
  },
  set: (element, string) => {
    return Promise.resolve().then(() => {
      return localStorage.setItem(element, string) === undefined ? true : false
    })
  }
}



// WEBPACK FOOTER //
// ./src/core/libs/storage.js